import { useQuery } from "data/hooks/useQuery";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PaymentDTO from "../dtos/PaymentDTO";
import { Payments_FinancialSettlement } from "data/endpoints";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { getQueryParams } from "features/shared/helpers/queryParams";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import PaymentUsageDetailHeader from "../components/PaymentUsageDetailHeader";
import Card from "features/shared/components/card/Card";
import PaymentUsageDetail from "../components/PaymentUsageDetail";
import FinancialSettlementInfoCard from "../components/FinancialSettlementInfoCard";
import DocumentDownloadCard from "features/shared/components/documents/DocumentDownloadCard";

type Props = {
  financialSettlementId: string;
};

const FinancialSettlementDetailSection = ({ financialSettlementId }: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  // store
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // side-effects
  // fetch data
  const { data: financialSettlement, loadStatus } = useQuery<PaymentDTO>(
    {
      url: Payments_FinancialSettlement,
      routeParams: getRouteParams("paymentId", financialSettlementId),
      params: getQueryParams("CustomerId", customer.customerId!),
    },
    {},
    [financialSettlementId]
  );

  // render
  return (
    <NoContentWrapper
      data={financialSettlement}
      loadStatus={loadStatus}
      noContentAsAlert
    >
      <div className="row no-gutters mx-n2">
        <div className="col-xl-8 px-2">
          <FinancialSettlementInfoCard
            financialSettlement={financialSettlement}
          />
        </div>
        <div className="col-xl-4 px-2">
          <DocumentDownloadCard
            documents={
              financialSettlement.financialSettlementDocument
                ? [financialSettlement.financialSettlementDocument]
                : []
            }
            expandToHeight
          />
        </div>
      </div>
      <div className="mt-sm-2">
        <h5 className="d-sm-none text-muted">
          {tLabels("paymentDetailSection.usedForPayment")}
        </h5>
        <PaymentUsageDetailHeader />
        {financialSettlement.paymentUsage?.map((item, index) => (
          <Card className="py-2 px-2 px-sm-3 mb-2" key={index}>
            <PaymentUsageDetail paymentUsage={item} />
          </Card>
        ))}
      </div>
    </NoContentWrapper>
  );
};

export default FinancialSettlementDetailSection;
